//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: ['Number', 'Account Name', 'Category', { title: 'Starting Balance', filter: 'toCurrency' }, { title: 'Beg Month', filter: 'toCurrency' }, { title: 'Change MTD', filter: 'toCurrency' }, { title: 'Change YTD', filter: 'toCurrency' }, { title: 'Current Balance', filter: 'toCurrency' }],
            fields: ['number', 'name', 'category', 'starting_balance', 'beg_balance', 'mtd', 'ytd', 'current_balance'],
            items: [],
            loading: true
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;
        var accounts = [];

        Event.$on('refresh-gl-accounts', function () {
            Event.$emit('data-table-loading');
            _this.items = [];
            axios.post('/prototype/accounting/general-ledger/accounts/list').then(function (response) {

                accounts = response.data;
                $el.items = accounts;
                Event.$emit('data-table-loaded');
            });
        });

        Event.$on('view-account', function (item, idx) {
            Event.$emit('show-flyout', 'GL Account Details', '', 'gl-account-details', item);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/accounts/AccountList.vue
// module id = 9Vpd
// module chunks = 0 1